import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";


const Main = lazy(() => import("../../../components/application/corporateProfileUpdate/changeOfAddress/main"));

const CorporateProfileUpdateChangeOfAddress = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default CorporateProfileUpdateChangeOfAddress;